<template>
  <div>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-autocomplete
              v-model="currFilters.title"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="title"
              :items="titles"
              :loading="loading"
              item-text="name"
              item-value="name"
              :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
              clearable
            ></v-autocomplete>
          </td>
          <td>
            <building-complexes-filter
              v-model="currFilters.building_complex"
              :label="$t('DATA_TABLE.FILTER')"
              item-text="name"
              item-value="id"
              :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
              multiple
              chips
              small-chips
              deletable-chips
              @change="getDataBuildings"
            />
          </td>
          <td>
            <v-autocomplete
              v-model="currFilters.building"
              :label="$t('DATA_TABLE.FILTER')"
              :items="buildings"
              :loading="loading"
              :search-input.sync="building"
              item-text="street"
              item-value="id"
              :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              @change="building = ''"
            ></v-autocomplete>
          </td>
          <td>
            <v-select
              v-model="currFilters.type"
              :items="types"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              clearable
            >
            </v-select>
          </td>
          <td>
            <v-select
              v-model="currFilters.mass_market"
              :items="[
                {
                  id: 1,
                  name: $t('YES_C')
                },
                {
                  id: 0,
                  name: $t('NO_C')
                }
              ]"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              clearable
            >
            </v-select>
          </td>
          <td>
            <v-select
              v-model="currFilters.status"
              :items="statuses"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              clearable
            >
            </v-select>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-btn color="primary" depressed @click.prevent="setFilters">
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { periodFormat } from '@/modules/_global/filters';
import { debounce, isEmpty } from 'lodash';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listFilters from '@/modules/_global/mixins/list-filters';
import BuildingComplexesFilter from '@/modules/_global/_components/list_filters/BuildingComplex/BuildingComplexesFilter.vue';

export default {
  name: 'BookingResourceListFilter',
  components: { BuildingComplexesFilter },

  filters: {
    periodFormat
  },

  mixins: [i18nRefreshData, listFilters],

  data: () => ({
    unwatch: null,
    options: {},
    delay: 500,
    payrollStatuses: [],
    types: [],
    statuses: [],

    title: null,

    building: null,
    titles: [],

    buildings: [],

    expensiveFunc: null
  }),

  computed: {
    ...mapState('booking_resources', ['filters']),
    ...mapState(['loading']),
    debouncedRequest() {
      return debounce(this.expensiveFunc, this.delay);
    },
    headers() {
      return [
        {
          text: this.$t('BOOKING.RESOURCES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          sortable: false
        },
        {
          text: this.$t('ITEM.TYPE'),
          sortable: false
        },
        {
          text: this.$t('BOOKING.RESOURCES.MASS_MARKET'),
          sortable: false
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: false
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ];
    }
  },

  watch: {
    title(val) {
      if (val !== this.currFilters.title && !isEmpty(val)) {
        this.expensiveFunc = this.getDataResources;
        this.debouncedRequest();
      }
    },

    'currFilters.building_complex': {
      immediate: true,
      handler: function(val) {
        if (!isEmpty(val)) {
          //  this.getDataBuildings();
        }
      }
    }
  },

  created() {
    this.refreshData();
    this.$nextTick(() => {
      this.getDataBuildings();
      this.getDataResources(this.currFilters.title);
    });
  },

  methods: {
    ...mapActions('booking_resources', [
      'getFilteredBuildingComplexes',
      'getFilteredBuildings',
      'getFilteredResources'
    ]),
    ...mapCacheActions('booking_resources', [
      'getBookingResourcesStatuses',
      'getBookingResourcesTypes'
    ]),

    refreshData() {
      this.getBookingResourcesStatuses()
        .then(({ data }) => {
          this.statuses = data.data;
        })
        .catch(error => {
          this.error = error;
        });
      this.getBookingResourcesTypes()
        .then(({ data }) => {
          this.types = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    getDataBuildings() {
      this.getFilteredBuildings({
        building_complex: this.currFilters.building_complex
      })
        .then(({ data }) => {
          this.buildings = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataResources(title = this.title) {
      this.getFilteredResources({ search: title })
        .then(({ data }) => {
          this.titles = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    remove(item) {
      const index = this.currFilters.status.indexOf(item.id);
      if (index >= 0) this.currFilters.status.splice(index, 1);
    },
    reset() {
      this.title = null;
      this.building = null;
      this.buildings = [];

      this.currFilters = {};

      this.refreshData();
    }
  }
};
</script>
